"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EditType", {
  enumerable: true,
  get: function () {
    return _EditType.default;
  }
});
exports.default = void 0;
var _EditType = _interopRequireDefault(require("./EditType"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const Editing = {
  EditType: _EditType.default
};
var _default = Editing;
exports.default = _default;